module.exports = __webpack_public_path__ + "img/portugal-neoplasm-male.a716e808.png";